import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { HumanInteractionService } from '../../../../services/human-interaction.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {WfTableComponent} from '../../../../common/table-sort/wf-table.component';
import {Subject} from 'rxjs';
import {CustomValidator} from '../../../../services/custom-validator';
import {Utils} from '../../../../services/utils';

@Component({
  selector: 'app-edit-queue-column-modal',
  templateUrl: './edit-queue-column-modal.component.html',
  styleUrls: ['./edit-queue-column-modal.component.css']
})
export class EditQueueColumnModalComponent implements OnInit {

  @Input() modalTitle: string;
  error = '';
  fieldError = '';
  objInitialState: any;
  columnForm: FormGroup;
  columnInfo;
  selectedBp;
  selectedField;
  availableBusinessProcessList;
  availableFields;
  businessProcessFieldList;
  itemSaved: Subject<any> = new Subject();
  disableBpList: boolean;
  isCustom = false;

  get businessProcessFieldsError() {
    if (this.isCustom) {
      return this.formData.type.value == '2' && (!this.selectedField || this.selectedField == 0 || this.selectedField == null);
    }
    return this.formData.type.value == '2' && (!this.businessProcessFieldList || this.businessProcessFieldList.length == 0);
  }

  get formData() { return this.columnForm.controls; }
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private humanInteractionService: HumanInteractionService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.columnInfo = this.objInitialState.column;
    this.availableBusinessProcessList = this.objInitialState.bps;
    this.disableBpList = false;

    // manter selecionado o processo de negócio e campo que vieram da configuração de filas nomeadas.
    if (this.objInitialState.selectedBp) {
      this.selectedBp = this.objInitialState.selectedBp;
      this.disableBpList = true; // não permitir alterar o processo de negócio
      this.isCustom = true; // desabilitar componentes da tela que não serão necessários
      this.onBpChange();
      this.selectedField = this.objInitialState.column.businessProcessFieldId;
    }
    this.createForm();
    this.loadData();
  }

  createForm() {
    this.columnForm = this.formBuilder.group({
      id: 0,
      name: ['', CustomValidator.trimRequired],
      columnOrder: 0,
      isEnabled: false,
      type: null,
      systemField: "",
      businessProcessFields: []
    });
  }

  loadData() {
    this.columnForm.patchValue({
      id: this.columnInfo.id,
      name: this.columnInfo.name,
      type: this.columnInfo.type ? this.columnInfo.type.toString() : this.columnInfo.type,
      columnOrder: this.columnInfo.columnOrder,
      isEnabled: this.columnInfo.isEnabled,
      systemField: this.columnInfo.systemField,
      businessProcessFields: this.columnInfo.businessProcessFields
    });
    this.updateTypeValidator();
    this.refreshBusinessProcessFieldTable();
  }

  onBpChange() {
    let bpId = this.selectedBp;
    let bp = this.availableBusinessProcessList.filter(bp => bp.businessProcessId == bpId);
    this.availableFields = bp[0].fields;
  }

  refreshBusinessProcessFieldTable(){
    if (this.formData.businessProcessFields.value){
      this.businessProcessFieldList = [];
      this.formData.businessProcessFields.value.forEach(bpf => {
        let obj = this.createDisplayFieldValue(bpf);
        this.businessProcessFieldList.push(obj);
      })
    }
  }

  createDisplayFieldValue(bpf){
    let errorMessage = '';
    let fieldDisplayName = '';
    let bp = this.availableBusinessProcessList.filter(bp => bp.businessProcessId == bpf.businessProcessId)[0];
    let filterResult = bp.fields.filter(f => f.fieldId == bpf.fieldId);
    if (!filterResult || filterResult.length != 1){
      errorMessage = "Campo não existe no processo de negócio publicado";
    } else{
      let field = filterResult[0];
      fieldDisplayName = field.name + (field.displayName != null && field.displayName != '' ? ' (' + field.displayName + ')' : '');
    }
    let obj = { 'businessProcessField': bpf, 'businessProcessName': bp.name, 'fieldDisplayName': fieldDisplayName, 'error': errorMessage};
    return obj;
  }

  addBpField(businessProcessId, fieldId) {
    let bpFieldList = this.formData.businessProcessFields.value;
    if (!bpFieldList) bpFieldList = [];

    let existsBpFieldFilter = bpFieldList.filter(f => f.businessProcessId == businessProcessId && f.fieldId == fieldId);
    if (existsBpFieldFilter && existsBpFieldFilter.length >0){
      this.fieldError="Este campo já foi adicionado";
      return;
    }

    let newBpField = {'id': this.businessProcessFieldList.length + 1, 'interactionQueueColumnId': this.formData.id.value, 'businessProcessId': businessProcessId, 'fieldId': fieldId};
    bpFieldList.push(newBpField);
    this.formData.businessProcessFields.setValue(bpFieldList);
    let obj = this.createDisplayFieldValue(newBpField);
    this.businessProcessFieldList.push(obj);
  }

  onRemoveField(field: any) {
    this.businessProcessFieldList.splice(this.businessProcessFieldList.indexOf(field), 1);

    let list = this.businessProcessFieldList.map(function(f){
      return f.businessProcessField;
    });
    this.formData.businessProcessFields.setValue(list);
  }

  onTypeChange() {
    if (this.formData.type.value == "1"){
      this.columnForm.get('systemField').setValidators([Validators.required, Validators.min(1)]);

      this.formData.businessProcessFields.setValue([]);
      this.businessProcessFieldList = [];
    } else {

      this.columnForm.get('systemField').clearValidators();
      this.columnForm.patchValue({
        systemField: 0
      });
    }
    this.columnForm.updateValueAndValidity();
  }

  onChangeIsEnabled() {
    this.updateTypeValidator();
    this.columnForm.patchValue({
      type: 0,
      systemField: 0,
      businessProcessFields: []
    });
  }

  updateTypeValidator(){
    if (this.formData.isEnabled.value){
      this.columnForm.get('type').setValidators([Validators.required]);
      if (this.formData.type.value == '0') {
        this.columnForm.get('type').setValue('1');
        this.onTypeChange();
      }
    } else {
      this.columnForm.get('type').clearValidators();
      this.columnForm.get('systemField').clearValidators();
    }
    this.columnForm.updateValueAndValidity();
  }

  onClickOk() {
    let raw = this.columnForm.getRawValue();
    if (raw.type){
      raw.type = Number(raw.type);
    }
    if (raw.systemField){
      raw.systemField = Number(raw.systemField);
    }
    if (this.isCustom) {
      raw.businessProcessFieldId = raw.type == 2 ? this.selectedField : 0;
      raw.customInteractionQueueId = this.columnInfo.customInteractionQueueConfigId;
      delete raw['businessProcessFields'];
    }

    this.columnInfo = raw;
    this.itemSaved.next(raw);
    this.bsModalRef.hide();
  }

  onClose() {
    this.bsModalRef.hide();
  }

  adjustSpaces(value, formControlName) {
    Utils.adjustSpaces(value, this.columnForm, formControlName);
  }
}
